import { network } from 'services/network';

export const getTemplate = (templateId) => {
    return network.post('api/bo/phaseperformance/getTemplate', { template_id: templateId }).then((response) => {
        return response.data;
    });
};
